import React from "react";

import { StyledContainer } from "@/layouts/common/RoundedFullPage/styles";
import { RoundedFullPageProps } from "@/layouts/common/RoundedFullPage/types";

export const RoundedFullPage: React.RFC<
  RoundedFullPageProps & { className?: string }
> = ({ header, children, className }) => {
  return (
    <StyledContainer className={className}>
      {header}
      {children}
    </StyledContainer>
  );
};
